module.exports = __webpack_public_path__ + "img/license_disk_vin.a5e2c813.png";